<template>
  <el-table-column
    v-bind="$attrs"
    ref="row"
  >
    <template slot-scope="scope" v-if="scope.column.type !== 'selection'">
      <div class="item" v-bind:class="{'align-right': $attrs.type === 'action'}">
        <initial-avatar 
          v-if="$attrs.type === 'username'"
          v-bind="$attrs" 
          :avatarUrl="scope.row.photo_url" 
          size="large" 
          :userObject="scope.row"
          :indx="scope.$index"
        />
        <span
        v-if="$attrs.type === 'username'"
        >
          <edit-roles-popover
            trigger="click"
            placement="bottom-end"
            width="225"
            :visible-arrow="true"
            v-on:show="populateUserInfo(scope.row.first_name, scope.row.last_name)"
          >
            <template v-slot:popover-title>
              <h3>{{$t('organizations.users_section.popovers.user.title')}}</h3>
            </template>
            <template v-slot:popover-body>
              <el-form ref="form" :model="formUser">
                <el-form-item :label="$t('user_profile.your_profile.first_name')">
                  <el-input v-model="formUser.first_name"></el-input>
                </el-form-item>
                <el-form-item :label="$t('user_profile.your_profile.last_name')">
                  <el-input v-model="formUser.last_name"></el-input>
                </el-form-item>
              </el-form>
            </template>

            <template v-slot:more-options>
              <primary-button
                @click.native="editUserInfo(scope.row.id)"
              >
              {{$t('common.save')}}
              </primary-button>
              <tertiary-button
                @click.native="$refs.row.$parent.$el.click"
              >
              {{$t('common.cancel')}}
              </tertiary-button>
            </template>

          <span>{{ scope.row.first_name }} {{scope.row.last_name}}</span>
          </edit-roles-popover>
          
        </span>

        <span v-if="$attrs.type !== 'roles' && $attrs.type !== 'username'">{{ scope.row[$attrs.type] }}</span>

        <div v-if="$attrs.type === 'roles'">
          <edit-roles-popover
            trigger="click"
            placement="bottom-end"
            width="225"
            :visible-arrow="true"
            v-on:show="populateRoles(scope.row[$attrs.type])"
          >
            <template v-slot:popover-title>
              <h3>{{$t('organizations.users_section.popovers.roles.title')}}</h3>
            </template>
            <template v-slot:popover-body>
              <el-checkbox-group
                class="elsa-checkbox-group"
                v-model="popover.selectedRole"
              >
                <el-checkbox
                  v-for="({value, label}, idx) in availableRoles"
                  :key="idx"
                  class="elsa-checkbox"
                  :label="value"
                >
                  {{$labelRole(currentOrganizationType, value)}}
                </el-checkbox>
              </el-checkbox-group>
            </template>

            <template v-slot:more-options>
              <primary-button
                :disabled="popover.selectedRole.length === 0"
                @click.native="editUserRoles(scope.row.id)"
              >
              {{$t('common.save')}}
              </primary-button>
              <tertiary-button
                @click.native="$refs.row.$parent.$el.click"
              >
              {{$t('common.cancel')}}
              </tertiary-button>
            </template>

          <span>
            <role
              class="role-pointer"
              v-for="(item, idx) in scope.row[$attrs.type]"
              :key="idx"
              :label="$labelRole(currentOrganizationType, item).toLowerCase()"
            />
          </span>
          </edit-roles-popover>
        </div>

        <div v-if="$attrs.type === 'action'" class="actions-popover">
          <more-options-popover
            placement="bottom-end"
            width="225"
            trigger="click"
            :visible-arrow="true"
            :displayData="getOrganizationGroups"
            :user="scope.row"
            :actionFunction="addToGroup"
            :isRowElement="true"
            :title="$t($i18nLabelsHelper(currentOrganizationType, 'add_to_group_title'))"
          >
            <template v-slot:moreOption>
              <span
                @click="handleAddGroupClick"
              >
                <i class="el-icon-circle-plus-outline"/>
                {{$t('organizations.users_section.popovers.classes.new_class')}}
              </span>
            </template>
            <chip-icon
              :tooltip="$t($i18nLabelsHelper(currentOrganizationType, 'add_to_group_title'))"
            >
              <ClassIcon />
            </chip-icon>
          </more-options-popover>
          <more-options-popover
            placement="bottom-end"
            width="225"
            trigger="click"
            @show="() => getUserGroups(scope.row)"
            :visible-arrow="true"
            :displayData="studentClasses"
            :user="scope.row"
            :actionFunction="handelRemoveFromGroup"
            :isRowElement="true"
            :title="$t($i18nLabelsHelper(currentOrganizationType, 'remove_from_group_tilte'))"
          >
            <chip-icon
                :tooltip="$t($i18nLabelsHelper(currentOrganizationType, 'remove_from_group_tilte'))"
                icon="elsa-icon-remove-student"
            />
          </more-options-popover>
          <assign-teacher-popover
            v-if="scope.row['roles'].includes(roleTeacher)"
            placement="bottom-end"
            width="225"
            trigger="click"
            @show="() => getUserGroups(scope.row)"
            :visible-arrow="true"
            :displayData="getOrganizationGroups"
            :user="scope.row"
            :isRowElement="true"
            :currentOrganizationType="currentOrganizationType"
            :title="$t($i18nLabelsHelper(currentOrganizationType, 'assign_teacher'))"
          >
            <chip-icon
                :tooltip="$t($i18nLabelsHelper(currentOrganizationType, 'assign_teacher'))"
                icon="elsa-icon-teacher"
            />
          </assign-teacher-popover>
          <more-options-popover
            v-if="scope.row['roles'].includes(roleTeacher)"
            placement="bottom-end"
            width="225"
            trigger="click"
            @show="() => getTeacherGroups(scope.row)"
            :visible-arrow="true"
            :displayData="teacherClasses"
            :user="scope.row"
            :actionFunction="handelRemoveTeacherFromGroup"
            :isRowElement="true"
            :title="$t($i18nLabelsHelper(currentOrganizationType, 'remove_teacher'))"
          >
            <chip-icon
                :tooltip="$t($i18nLabelsHelper(currentOrganizationType, 'remove_teacher'))"
                icon="elsa-icon-remove-student"
            />
          </more-options-popover>
        </div>
      </div>
    </template>
  </el-table-column>
</template>

<script>
  import Role from '@/components/common/Role'
  import ChipIcon from '@/components/common/ChipIcon'
  import MoreOptionsPopover from '@/components/common/MoreOptionsPopover'
  import AssignTeacherPopover from '@/components/common/AssignTeacherPopover'
  import EditRolesPopover from '@/components/common/EditRolesPopover'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import ClassIcon from '@/assets/icons/inline.class.svg'
  import { selectUserRoles } from '@/constants/userRoles'
  import InitialAvatar from '@/components/common/InitialAvatar'
  import {
    map,
    toLower,
    propEq,
    compose,
    propOr,
    any,
    of,
    prop,
    filter,
    pathOr,
    find
  } from 'ramda'
  import { mapGetters, mapActions } from 'vuex'
  import { successMessage, warningMessage } from '../../utils/messages'

  export default {
    components: {
      Role,
      ChipIcon,
      MoreOptionsPopover,
      ClassIcon,
      EditRolesPopover,
      PrimaryButton,
      TertiaryButton,
      InitialAvatar,
      AssignTeacherPopover
    },
    props: ['value', 'organizationId'],
    data() {
      return {
        visible: false,
        popover: {
          selectedRole:[],
        },
        formUser: {
          first_name: null,
          last_name: null
        },
        studentClasses: [],
        roleTeacher: 'teacher',
        teacherClasses: []
      }
    },
    computed: {
      getOrganizationGroups: propOr([], 'getClassList'),
      availableRoles () { return selectUserRoles },
      ...mapGetters('classes', [
         'getClassList'
      ]),
      ...mapGetters('organization', [
        'currentOrganizationType'
      ]),
      messageConfirmRemoveUser() {
        return this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "confirm_remove_user_from_group"));
      },
      messageConfirmRemoveTeacher(){
        return this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "confirm_remove_teacher_from_group"));
      }
    },
    methods: {
      userHasPendingInvites(user) {
        const inviteStatus = compose(
          any(propEq('status', 'Pending')),
          propOr([], 'pending_invitations')
        )(user)

        return inviteStatus
      },
      async addToGroup(groupId, user) {
        const students = compose(of, prop('email'))(user)
        try {
          await this.addUsersToClass({
            students,
            groupId,
          })
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, 'add_to_group_success')

          return successMessage(this.$t(message))(this)
        } catch(e) {
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, 'add_to_group_warning')

          return warningMessage(this.$t(message))(this)
        }
      },
      handelRemoveFromGroup(groupId, user) {
        this.$confirm(this.messageConfirmRemoveUser, this.$t('organizations.invite_users.confirmation_title'), {
          confirmButtonText: this.$t("student.yes"),
          cancelButtonText: this.$t("student.no"),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.removeFromGroup(groupId, user)
        }).catch(() => {
          return
        });
      },
      async removeFromGroup(groupId, user) {
        const studentId = compose(of, prop('id'))(user);
        try {
          await this.removeUserFromClass({groupId, studentId})
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, 'remove_from_group_success')
          return successMessage(this.$t(message))(this)
        }
        catch(e){
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, 'remove_from_group_warning')
          return warningMessage(this.$t(message))(this)
        }
      },
      handelRemoveTeacherFromGroup(groupId) {
        this.$confirm(this.messageConfirmRemoveTeacher, this.$t('organizations.invite_users.confirmation_title'), {
          confirmButtonText: this.$t("student.yes"),
          cancelButtonText: this.$t("student.no"),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.removeTeacherFromGroup(groupId)
        }).catch(() => {
          return
        });
      },
      async removeTeacherFromGroup(groupId) {
        try {
          const groupName = compose(propOr('', 'name'), find(propEq('id', groupId)))(this.getOrganizationGroups)
          await this.removeTeacherFromClass({groupId, groupName})
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, 'remove_teacher_from_group_success')
          successMessage(this.$t(message))(this)
          return this.getClasses();
        }
        catch(e){
          const message = this.$i18nLabelsHelper(this.currentOrganizationType, 'remove_teacher_from_group_warning')
          return warningMessage(this.$t(message))(this)
        }
      },
      revokeLicense() {
      },
      enableLicense(userData) {
        const { firstName, lastName } = userData;
        const h = this.$createElement;
        this.$message({
          message: h('p', null, [
            h('span', null, this.$t('organizations.users_section.enable_license_message', { firstName, lastName })),
            h('a', { on: {click: () => this.revokeLicense(userData) }}, 'Undo')
          ]),
          center: true,
          customClass: 'elsa-message',
          offset: 115,
          iconClass: '',
        })
      },
      handleAddGroupClick() {
        this.$router.push({
          name: 'classes-new',
          params: {
            organizationId: this.organizationId
          }
        })
      },
      handleManageGroupsClick() {},
      handleAddClassClick() {},
      getParent(){return this.$parent},
      populateUserInfo(first_name, last_name) {
        this.formUser.first_name = first_name;
        this.formUser.last_name = last_name;
      },
      async editUserInfo(userId){
        const organizationId = this.organizationId;
        const {first_name, last_name} = this.formUser;
        try {
          await this.$store.dispatch('organization/updateOrganizationUserInfo', {organizationId, userId, first_name, last_name})
          successMessage(this.$t('user_profile.your_profile.modals.edit_profile.update_success'))(this)
          this.$refs.row.$parent.$el.click()
        }
        catch (e) {
          warningMessage(this.$t('user_profile.your_profile.modals.edit_profile.update_warning'))(this)
          this.$refs.row.$parent.$el.click()
        }
      },
      populateRoles(roles){
        this.popover.selectedRole = map(toLower, roles)
      },
      async editUserRoles (userId) {
        const roles = this.popover.selectedRole
        const organizationId = this.organizationId
        await this.$store.dispatch('organization/postOrganizationUser', { organizationId, userId, roles})
        this.$refs.row.$parent.$el.click()
      },
      async getUserGroups(rowUser) {
        const studentId = compose(of, prop('id'))(rowUser);
        await this.getStudentClasses({
          organizationId: this.organizationId,
          studentId: studentId,
        });
        this.studentClasses = propOr([], 'results')(this.$store.state.students.studentClasses)
      },
      getTeacherGroups(rowUser) {
        const teacherId = compose(of, prop('id'))(rowUser);
        const isOwner = group => pathOr('', ['owner', 'id'])(group) == teacherId;
        this.teacherClasses = filter(isOwner, this.getOrganizationGroups);
      },
      ...mapActions('classes', [
        'addUsersToClass',
        'removeUserFromClass',
        'removeTeacherFromClass',
        'getClasses'
      ]),
      ...mapActions('students', [
        'getStudentClasses'
      ])
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_colors.scss";

  ::v-deep.item {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: $gray;
    &.align-right {
      justify-content: flex-end;
    }

    & > span, .el-tag {
      margin-left: 10px;
    }

    img {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }
  }
  .el-table__row:hover {
    button{
      background: none;
      border: none;
      &:hover, &:focus {
        background: none;
      }
      &:active {
        color: $purple;
      }
    }
  }

  .actions-popover {
    width: 200px;
    display: flex;
    flex-direction: row;

    span button.elsa-chip {
      height: 100%;

      span {
        height: 100%;

        svg {
          height: 100%;
          width: auto;
        }
      }
    }
  }

  .role-pointer {
    cursor: pointer;
  }
</style>
